// Course certificates workspace (CourseOverview → "Sertifikatlar" tab and /courses/:id/certificates).
const certs = {
  en: {
    tab: 'Certificates',
    title: 'Certificates',
    subtitle: "The design students get, the authors printed on it, and every student's certificate.",
    statIssued: 'Issued',
    statRevoked: 'Revoked',
    statDesign: 'Design',
    loadError: 'Could not load certificate data.',
    accessDenied: "You do not have access to this course's certificates.",
    parent: 'Course workspace',
    backToCourse: 'Back to course',
    moreActions: 'More actions',
    studentsCount: '{count} students',
    samplePdfHint: 'Sample certificate PDF for this course',
    cancel: 'Cancel',

    designTitle: 'Certificate design',
    designSub: 'Students see a sample in this design with their own name while they study.',
    designNoteIssued: 'Applies to certificates issued from now on — the {count} already issued keep their design.',
    designNoteNone: 'Applies to every certificate of this course.',
    current: 'Current',
    default: 'Default',
    saveDesign: 'Save design',
    saving: 'Saving...',
    designSaved: 'Certificate design saved.',
    designSaveFailed: 'Could not save the design.',
    samplePdf: 'PDF sample',
    sampleFailed: 'Could not render the sample.',

    authorsTitle: 'Authors on the certificate',
    authorsSub: 'Up to three people printed at the bottom of the certificate, with their titles.',
    authorName: 'Full name',
    authorTitle: 'Title (Uzbek)',
    authorTitleEn: 'Title (English)',
    authorNamePh: 'e.g. Dilnoza Karimova',
    authorTitlePh: "e.g. Rus tili o'qituvchisi",
    authorTitleEnPh: 'e.g. Russian language teacher',
    addAuthor: 'Add author',
    removeAuthor: 'Remove author',
    moveUp: 'Move up',
    moveDown: 'Move down',
    authorsEmpty: 'No authors yet — the certificate prints without an author row.',
    titleEnLabel: 'English course title',
    titleEnHint: 'Printed under the course title. Leave empty if it is the same.',
    titleEnPh: 'e.g. Russian Language: Beginner',
    saveAuthors: 'Save authors',
    authorsSaved: 'Authors saved.',
    authorsSaveFailed: 'Could not save the authors.',
    errName: 'Name must be 2–80 characters.',
    errTitle: 'Title must be 2–120 characters.',
    errTitleEn: 'English title must be at most 120 characters.',
    unsaved: 'Unsaved changes',

    studentsTitle: 'Students',
    studentsSub: 'Certificates are issued automatically when a student completes the course. Issue manually only if one is missing.',
    colStudent: 'Student',
    colProgress: 'Progress',
    colCompleted: 'Completed on',
    colCertificate: 'Certificate',
    colStatus: 'Status',
    colActions: 'Actions',
    statusIssued: 'Issued',
    statusRevoked: 'Revoked',
    statusReady: 'Ready to issue',
    statusInProgress: 'In progress',
    distinction: 'With distinction',
    actionIssue: 'Issue',
    actionIssuing: 'Issuing...',
    actionOpenPdf: 'PDF',
    actionCopyLink: 'Copy link',
    copied: 'Copied',
    actionVerify: 'Verify',
    actionRevoke: 'Revoke',
    actionReissue: 'Re-issue',
    issued: 'Certificate issued.',
    issueFailed: 'Could not issue the certificate.',
    copyFailed: 'Could not copy the link.',
    selectAllReady: 'Select all ready ({count})',
    issueSelected: 'Issue selected ({count})',
    issuingProgress: 'Issuing {done}/{total}...',
    bulkDone: '{succeeded} of {total} certificates issued.',
    studentsEmptyTitle: 'No students yet',
    studentsEmptyDesc: 'Students enrolled in this course will appear here with their certificate status.',

    revokeTitle: 'Revoke certificate {number}?',
    revokeBody: 'The verify page will show it as revoked and the PDF gets a "REVOKED" watermark. The student keeps access to the course.',
    reasonLabel: 'Reason',
    reasonHint: '3–300 characters, shown in the audit history.',
    confirmRevoke: 'Revoke certificate',
    revoked: 'Certificate revoked.',
    revokeFailed: 'Could not revoke the certificate.',
    reissueTitle: 'Re-issue certificate {number}?',
    reissueBody: 'A new number and QR code are issued; the old QR will read "replaced". Use this to correct the name or after a revoke.',
    nameLabel: 'Corrected name (optional)',
    nameHint: 'Leave empty to keep "{name}".',
    confirmReissue: 'Re-issue',
    reissued: 'Certificate re-issued.',
    reissueFailed: 'Could not re-issue the certificate.',
  },
  ru: {
    tab: 'Сертификаты',
    title: 'Сертификаты',
    subtitle: 'Дизайн, который получат студенты, авторы на сертификате и сертификат каждого студента.',
    statIssued: 'Выдано',
    statRevoked: 'Отозвано',
    statDesign: 'Дизайн',
    loadError: 'Не удалось загрузить данные сертификатов.',
    accessDenied: 'У вас нет доступа к сертификатам этого курса.',
    parent: 'Управление курсом',
    backToCourse: 'Назад к курсу',
    moreActions: 'Другие действия',
    studentsCount: '{count} студентов',
    samplePdfHint: 'PDF-образец сертификата для этого курса',
    cancel: 'Отмена',

    designTitle: 'Дизайн сертификата',
    designSub: 'Во время обучения студенты видят образец в этом дизайне со своим именем.',
    designNoteIssued: 'Применяется к сертификатам, выданным с этого момента — уже выданные ({count}) сохраняют свой дизайн.',
    designNoteNone: 'Применяется ко всем сертификатам курса.',
    current: 'Текущий',
    default: 'Основной',
    saveDesign: 'Сохранить дизайн',
    saving: 'Сохранение...',
    designSaved: 'Дизайн сертификата сохранён.',
    designSaveFailed: 'Не удалось сохранить дизайн.',
    samplePdf: 'PDF-образец',
    sampleFailed: 'Не удалось построить образец.',

    authorsTitle: 'Авторы на сертификате',
    authorsSub: 'До трёх человек с должностями — печатаются внизу сертификата.',
    authorName: 'Полное имя',
    authorTitle: 'Должность (узб.)',
    authorTitleEn: 'Должность (англ.)',
    authorNamePh: 'например, Дилноза Каримова',
    authorTitlePh: "например, Rus tili o'qituvchisi",
    authorTitleEnPh: 'например, Russian language teacher',
    addAuthor: 'Добавить автора',
    removeAuthor: 'Удалить автора',
    moveUp: 'Выше',
    moveDown: 'Ниже',
    authorsEmpty: 'Авторов пока нет — сертификат печатается без строки авторов.',
    titleEnLabel: 'Название курса на английском',
    titleEnHint: 'Печатается под названием курса. Оставьте пустым, если совпадает.',
    titleEnPh: 'например, Russian Language: Beginner',
    saveAuthors: 'Сохранить авторов',
    authorsSaved: 'Авторы сохранены.',
    authorsSaveFailed: 'Не удалось сохранить авторов.',
    errName: 'Имя — от 2 до 80 символов.',
    errTitle: 'Должность — от 2 до 120 символов.',
    errTitleEn: 'Должность на английском — не более 120 символов.',
    unsaved: 'Есть несохранённые изменения',

    studentsTitle: 'Студенты',
    studentsSub: 'Сертификат выдаётся автоматически, когда студент заканчивает курс. Выдавайте вручную, только если его нет.',
    colStudent: 'Студент',
    colProgress: 'Прогресс',
    colCompleted: 'Дата окончания',
    colCertificate: 'Сертификат',
    colStatus: 'Статус',
    colActions: 'Действия',
    statusIssued: 'Выдан',
    statusRevoked: 'Отозван',
    statusReady: 'Можно выдать',
    statusInProgress: 'Учится',
    distinction: 'С отличием',
    actionIssue: 'Выдать',
    actionIssuing: 'Выдаём...',
    actionOpenPdf: 'PDF',
    actionCopyLink: 'Ссылка',
    copied: 'Скопировано',
    actionVerify: 'Проверить',
    actionRevoke: 'Отозвать',
    actionReissue: 'Перевыпустить',
    issued: 'Сертификат выдан.',
    issueFailed: 'Не удалось выдать сертификат.',
    copyFailed: 'Не удалось скопировать ссылку.',
    selectAllReady: 'Выбрать все готовые ({count})',
    issueSelected: 'Выдать выбранные ({count})',
    issuingProgress: 'Выдаём {done}/{total}...',
    bulkDone: 'Выдано {succeeded} из {total} сертификатов.',
    studentsEmptyTitle: 'Студентов пока нет',
    studentsEmptyDesc: 'Записавшиеся на курс студенты появятся здесь со статусом сертификата.',

    revokeTitle: 'Отозвать сертификат {number}?',
    revokeBody: 'Страница проверки покажет его как отозванный, а на PDF появится отметка «ОТОЗВАН». Доступ к курсу у студента остаётся.',
    reasonLabel: 'Причина',
    reasonHint: 'От 3 до 300 символов, попадёт в историю.',
    confirmRevoke: 'Отозвать сертификат',
    revoked: 'Сертификат отозван.',
    revokeFailed: 'Не удалось отозвать сертификат.',
    reissueTitle: 'Перевыпустить сертификат {number}?',
    reissueBody: 'Будут выданы новый номер и QR-код; старый QR покажет «заменён». Используйте, чтобы исправить имя или после отзыва.',
    nameLabel: 'Исправленное имя (необязательно)',
    nameHint: 'Оставьте пустым, чтобы сохранить «{name}».',
    confirmReissue: 'Перевыпустить',
    reissued: 'Сертификат перевыпущен.',
    reissueFailed: 'Не удалось перевыпустить сертификат.',
  },
  uz: {
    tab: 'Sertifikatlar',
    title: 'Sertifikatlar',
    subtitle: "O'quvchilar oladigan dizayn, sertifikatdagi mualliflar va har bir o'quvchining sertifikati.",
    statIssued: 'Berilgan',
    statRevoked: 'Bekor qilingan',
    statDesign: 'Dizayn',
    loadError: "Sertifikat ma'lumotlarini yuklab bo'lmadi.",
    accessDenied: "Bu kurs sertifikatlariga ruxsatingiz yo'q.",
    parent: 'Kurs boshqaruvi',
    backToCourse: 'Kursga qaytish',
    moreActions: "Boshqa amallar",
    studentsCount: "{count} ta o'quvchi",
    samplePdfHint: "Shu kurs uchun sertifikat namunasi (PDF)",
    // "Bekor qilish" is also what revoking a certificate is called here, so the dialog's way out is "Yopish"
    cancel: 'Yopish',

    designTitle: 'Sertifikat dizayni',
    designSub: "O'qish davomida o'quvchilar shu dizayndagi namunani o'z ismi bilan ko'radi.",
    designNoteIssued: "Bundan keyin beriladigan sertifikatlarga qo'llanadi — allaqachon berilgan {count} tasi o'z dizaynida qoladi.",
    designNoteNone: "Kursning barcha sertifikatlariga qo'llanadi.",
    current: 'Joriy',
    default: 'Asosiy',
    saveDesign: 'Dizaynni saqlash',
    saving: 'Saqlanmoqda...',
    designSaved: 'Sertifikat dizayni saqlandi.',
    designSaveFailed: "Dizaynni saqlab bo'lmadi.",
    samplePdf: 'PDF namuna',
    sampleFailed: "Namunani yaratib bo'lmadi.",

    authorsTitle: 'Sertifikatdagi mualliflar',
    authorsSub: "Sertifikat pastida lavozimi bilan yoziladigan ko'pi bilan uch kishi.",
    authorName: "To'liq ism",
    authorTitle: "Lavozim (o'zbekcha)",
    authorTitleEn: 'Lavozim (inglizcha)',
    authorNamePh: 'masalan, Dilnoza Karimova',
    authorTitlePh: "masalan, Rus tili o'qituvchisi",
    authorTitleEnPh: 'masalan, Russian language teacher',
    addAuthor: "Muallif qo'shish",
    removeAuthor: "Muallifni o'chirish",
    moveUp: 'Yuqoriga',
    moveDown: 'Pastga',
    authorsEmpty: "Mualliflar hali yo'q — sertifikat mualliflar qatorisiz chiqadi.",
    titleEnLabel: 'Kursning inglizcha nomi',
    titleEnHint: "Kurs nomi ostida yoziladi. Bir xil bo'lsa, bo'sh qoldiring.",
    titleEnPh: 'masalan, Russian Language: Beginner',
    saveAuthors: 'Mualliflarni saqlash',
    authorsSaved: 'Mualliflar saqlandi.',
    authorsSaveFailed: "Mualliflarni saqlab bo'lmadi.",
    errName: "Ism 2–80 belgidan iborat bo'lsin.",
    errTitle: "Lavozim 2–120 belgidan iborat bo'lsin.",
    errTitleEn: "Inglizcha lavozim 120 belgidan oshmasin.",
    unsaved: "Saqlanmagan o'zgarishlar bor",

    studentsTitle: "O'quvchilar",
    studentsSub: "O'quvchi kursni tugatganda sertifikat avtomatik beriladi. Qo'lda faqat yetishmayotgan bo'lsa bering.",
    colStudent: "O'quvchi",
    colProgress: 'Progress',
    colCompleted: 'Tugatgan sana',
    colCertificate: 'Sertifikat',
    colStatus: 'Holat',
    colActions: 'Amallar',
    statusIssued: 'Berilgan',
    statusRevoked: 'Bekor qilingan',
    statusReady: 'Berishga tayyor',
    statusInProgress: "O'qiyapti",
    distinction: "A'lo natija",
    actionIssue: 'Berish',
    actionIssuing: 'Berilmoqda...',
    actionOpenPdf: 'PDF',
    actionCopyLink: 'Havola',
    copied: 'Nusxalandi',
    actionVerify: 'Tekshirish',
    actionRevoke: 'Sertifikatni bekor qilish',
    actionReissue: 'Qayta berish',
    issued: 'Sertifikat berildi.',
    issueFailed: "Sertifikatni berib bo'lmadi.",
    copyFailed: "Havolani nusxalab bo'lmadi.",
    selectAllReady: 'Tayyorlarning barchasi ({count})',
    issueSelected: 'Tanlanganlarga berish ({count})',
    issuingProgress: 'Berilmoqda {done}/{total}...',
    bulkDone: '{total} tadan {succeeded} ta sertifikat berildi.',
    studentsEmptyTitle: "Hali o'quvchilar yo'q",
    studentsEmptyDesc: "Kursga yozilgan o'quvchilar sertifikat holati bilan shu yerda ko'rinadi.",

    revokeTitle: '{number} sertifikatini bekor qilasizmi?',
    revokeBody: "Tekshiruv sahifasida bekor qilingan deb ko'rsatiladi, PDF'ga \"BEKOR QILINGAN\" belgisi tushadi. O'quvchining kursga kirishi saqlanadi.",
    reasonLabel: 'Sabab',
    reasonHint: '3–300 belgi, tarixda saqlanadi.',
    confirmRevoke: 'Sertifikatni bekor qilish',
    revoked: 'Sertifikat bekor qilindi.',
    revokeFailed: "Sertifikatni bekor qilib bo'lmadi.",
    reissueTitle: '{number} sertifikatini qayta berasizmi?',
    reissueBody: "Yangi raqam va QR kod beriladi; eski QR \"almashtirilgan\" deb ko'rsatadi. Ismni tuzatish yoki bekor qilingandan keyin ishlating.",
    nameLabel: "Tuzatilgan ism (ixtiyoriy)",
    nameHint: "\"{name}\" qolishi uchun bo'sh qoldiring.",
    confirmReissue: 'Qayta berish',
    reissued: 'Sertifikat qayta berildi.',
    reissueFailed: "Sertifikatni qayta berib bo'lmadi.",
  },
};

export default certs;
